<div class="container-fluid bg-gray-200">
	<div class="container py-2">

		<ascedia-breadcrumbs
			[breadcrumbs]="breadcrumbs" 
			className="mb-0 px-0"
			*ngIf="breadcrumbs"></ascedia-breadcrumbs>

	</div>
</div>

<div class="container-fluid px-0" *ngIf="product">
	<div class="container pt-5 pb-4 text-secondary">

		<div class="d-md-flex ">
			
			<div class="">
				<h1 class="font-family-accent">{{product.useName}}</h1>
				<div class=" d-md-flex small mb-2">
					<div class="location mr-3"><fa-icon [icon]="['fas', 'map-marker-alt']" class="mr-2"></fa-icon>{{product.destination.name}}, {{product.destination.countryName}}</div>
					<div class="rating mr-3 hidden"><fa-icon [icon]="['fas', 'thumbs-up']" class="mr-2"></fa-icon>Ratingname (123 ratings)</div>
				</div>
				<!-- <a class="btn btn-outline-primary pill mr-2 no-break small" 
					[routerLink]="" 
					[fragment]="'addToBoard-' + product.id" ><fa-icon [icon]="['fas', 'plus']" class="mr-2"></fa-icon>Add to Travel Board</a> -->
			</div>

			

			<div class="d-flex pl-md-4 mt-3 mt-md-0 align-items-start  ml-auto">
				<a class="btn btn-outline-primary pill no-break " 
					[routerLink]="" 
					[fragment]="'addToBoard-' + product.id"
					*ngIf="userAppAccess?.activeAccount?.localAccountId" >
					<fa-icon [icon]="['fas', 'plus']" class=""></fa-icon>
				</a>
				<!-- <div class="btn btn-outline-primary pill mr-2 no-break"><fa-icon [icon]="['fas', 'th']" class="mr-2"></fa-icon> All Photos</div>
				<div class="btn btn-outline-primary pill mr-2"><fa-icon [icon]="['far', 'heart']"></fa-icon></div>
				<div class="btn btn-outline-primary pill"><fa-icon [icon]="['fas', 'share-square']"></fa-icon></div> -->
			</div>

		</div>

	</div>


	<ng-container *ngIf="sliderListBg; else noSliderListBg">
		<ascedia-swiper-background-image className="mb-5"
			[config]="config"
			[sliderList]="sliderListBg"
			text=""
			className="overlay-xl-arrows unpad-bottom slide-auto-width"
			>
		</ascedia-swiper-background-image>
	</ng-container>
	<ng-template #noSliderListBg>
		<div class="my-3 container text-small text-muted">No images found.</div>
	</ng-template>

</div>


<app-anchor-tabs 
	*ngIf="anchorTabs"
	[anchorTabs]="anchorTabs"
	[anchorOptions]="anchorOptions"
	#anchorTabComp
	></app-anchor-tabs>


<div class="container-fluid bg-gray-200 py-5 text-primary content">

	<div class="container bg-white rounded-corners content-inner xtra-pad mb-4" 
		id="overview"
		(visibilityChange)="anchorTabComponent.visibilityChangeHandler($event)" 
		enterTheViewportNotifier
		>
		<div class="row">
			<div class="col-12 col-md-8 mb-3 mb-md-0">
				<h3 class="font-weight-bold text-secondary">Excursion Overview</h3>
				<div class="ataglance">
					<!-- <div class="font-weight-bold">At a Glance</div>
					<div class="mb-3 text-danger">tags and icons to come here</div> -->
					<h5 class="font-weight-bold text-secondary">About the Excursion</h5>

					<app-read-more 
						[isAnimated]="false" 
						minHeight="90" 
						maxHeight="1000"
						*ngIf="product?.content?.description"
						>
						<markdown class="text-gray" ngPreserveWhitespaces [innerHTML]="product?.content?.description"></markdown>
						<span class="read-more-text">Read More</span>
						<span class="read-less-text">Read Less</span>
					</app-read-more>
					<!-- <markdown class="text-gray" ngPreserveWhitespaces [innerHTML]="product?.content?.description"></markdown> -->
					
				</div>
			</div>
			<div class="minw-300">
				<div class="rounded-corners drop-shadow px-4 py-3 text-secondary mb-3">
					<h3 class="font-weight-bold  mb-1">Pricing</h3>
					<div class="font-weight-medium mb-2" *ngIf="product?.startingAt">Starting at ${{product.startingAt}}</div>
					<div class="btn btn-primary pill font-weight-bold w-100" (click)="anchorTabClick('pricing')">View Schedules & Details</div>
				</div>
			</div>
		</div>
	</div>



	<div class="container bg-white rounded-corners content-inner xtra-pad mb-4" 
		id="pricing"
		(visibilityChange)="anchorTabComponent.visibilityChangeHandler($event)" 
		enterTheViewportNotifier
		>
		<div class="row">
			<div class="col-12">
				<div class="d-md-flex align-items-baseline">
					<div class="mb-3 position-relative">
						<h3 class="font-weight-bold text-secondary">Schedules & Details </h3>
						<h6 class="text-secondary">Schedules for {{calBtnActiveDate | date : 'MMMM dd, yyyy'}}</h6>
						<!-- <h6 class="text-secondary">Schedules for {{searchStartDate | date : 'MMMM dd, yyyy'}} <span *ngIf="searchStartDate.getTime() != searchEndDate.getTime()">to {{searchEndDate | date : 'MMMM dd, yyyy'}}</span></h6> -->
						<!-- <div class="bred">{{displayDate | date : 'MMMM dd, yyyy'}}</div> -->
					</div>
					<div class="ml-auto">
						<div class="ml-auto btn btn-link px-0" (click)="dp.toggle();"><fa-icon [icon]="['fad', 'calendar-alt']"></fa-icon> Select Dates</div>
						<input type="text"
							placeholder="Daterangepicker"
							class="form-control mb-3 hide-input"
							bsDaterangepicker
							#dp="bsDaterangepicker"
							[bsValue]="bsRangeValue"
							[bsConfig]="bsConfig"
							[minDate]="minDate"
							[maxDate]="maxDate"
							[dateCustomClasses]="dateCustomClasses"
							(bsValueChange)="onDateChange($event)"
							>
						<!-- <input type="text"
							placeholder="Datepicker"
							class="form-control mb-3 hide-input"
							bsDatepicker
							#dp="bsDatepicker"
							[bsValue]="loadDate"
							[bsConfig]="bsConfig"
							[minDate]="minDate"
							[maxDate]="maxDate"
							[dateCustomClasses]="dateCustomClasses"
							(bsValueChange)="onDateChange($event)"
							> -->
					</div>

				</div>

				<div class="mb-3 button-slider-wrapper "
					#buttonSliderWrapper
					>
					<div class=" button-slider" 
						[ngStyle]="{'left.px': buttonSliderX}"
						#buttonSlider>
						<button *ngFor="let btn of calBtns;"
							class="btn pill mr-2 no-break calbtn" 
							[class.btn-primary]="btn.isActive"
							[class.btn-outline-primary]="!btn.isActive"
							[disabled]="btn.isDisabled"
							(click)="setActiveCalendarButton(btn)"
							>{{btn.date | date: 'E. LLL dd'}}</button>
					</div>

					<div class="button-slider-btn-prev" 
						(click)="buttonSlide(1)"
						*ngIf="showButtonSliderPrev">
						<div class="btn btn-quaternary btn-circle-icon text-light">
							<fa-icon [icon]="['fas', 'chevron-left']"></fa-icon>
						</div>
					</div>
					<div class="button-slider-btn-next"
						(click)="buttonSlide(-1)"
						*ngIf="showButtonSliderNext">
						<div class="btn btn-quaternary btn-circle-icon text-light">
							<fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
						</div>
					</div>

				</div>

				<div class="alert alert-warning d-flex" role="alert" *ngIf="arriveDate && itinerary">
					<div class="icon mr-3 pt-1">
						<fa-icon [icon]="['far', 'lightbulb-on']" class="display-6"></fa-icon>
					</div>
					<div class="info">
						<div class="font-weight-bold"><i>Double-Check Excursion Times</i></div>
						<div class=""><i>Please note that all times for an excursion will appear on this page. You must select the time that works with your time in port. Please refer to the cruise itinerary provided. If you need assistance, feel free to <a [routerLink]="['/support/contact-us']" class="p-0 m-0">contact us.</a></i></div>
					</div>
				</div>


				<!-- <div class="bred">{{calBtnActiveDate}}</div> -->

				<ng-template #noOccurrences>
					<div *ngIf="calBtnActiveDate">None found for {{calBtnActiveDate | date : 'MMMM dd, yyyy'}}</div>
				</ng-template>

				<ng-container *ngIf="filteredOccurrences && filteredOccurrences.length > 0; else noOccurrences">

					<div *ngFor="let occurrence of filteredOccurrences; let i = index; "
						class="rounded-corners b-gray-300 p-3 p-md-4 mb-2 ticketpackage"
						>

						<div class="d-flex align-items-baseline mb-2">
							<div class="pr-3">
								<h4 class="font-weight-bold mb-1 clickable" (click)="toggleOccurrence(occurrence)">{{occurrence.useName}}</h4>
								<!-- <div class="text-gray-600 font-weight-medium">Starting Time: <span *ngIf="occurrence.startTime">{{occurrence.startTime | date: 'h:mm a'}}</span><span *ngIf="!occurrence.startTime">{{occurrence.otherStartTime}}</span></div> -->
								<div class="text-gray-600 font-weight-medium">Starting Time: <span *ngIf="occurrence.startTimeUtc">{{occurrence.startTimeUtc}}</span><span *ngIf="!occurrence.startTimeUtc">{{occurrence.otherStartTime}}</span></div>
							</div>
							
							<div class="ml-auto btn btn-link pr-0 toggle-btn" 
								[ngClass]="{'active': occurrence.isVisible}"
								(click)="toggleOccurrence(occurrence)" >
								<fa-icon [icon]="['fas', 'chevron-down']" *ngIf="!occurrence.isVisible"></fa-icon>
								<fa-icon [icon]="['fas', 'chevron-up']" *ngIf="occurrence.isVisible"></fa-icon>
							</div>
						</div>

						<div class="toggle-body" [ngClass]="{'active': occurrence.isVisible}">
							<div class="row">
								<div class="col-12 col-md-4 mb-3 mb-md-0">
									<div class="mb-2">
										<fa-icon 
											[icon]="['far','clock']" 
											class="mr-2" 
											[fixedWidth]="true"></fa-icon>
										<span>{{occurrence.duration}} hours</span>
									</div>
									<div class="mb-2">
										<fa-icon 
											[icon]="['fas','dollar-sign']" 
											class="mr-2" 
											[fixedWidth]="true"></fa-icon>
										<span>Starting at ${{occurrence.startingAt}}</span>
									</div>

									
								</div>
								<div class="col-12 col-md-4 mb-3 mb-md-0">
									<div class="rounded-corners b-gray-300">
										<a class="px-3 py-2 btn btn-link d-flex" (click)="openTicketsModal (ticketsTemplate, occurrence)"><fa-icon [icon]="['fal', 'ticket-alt']" class="rotate-30 d-inline-block mr-3"></fa-icon> Select Quantity <fa-icon [icon]="['fas', 'plus']" class="ml-auto"></fa-icon></a>
										<div class="px-3 py-2 bg-gray-200"
											*ngIf="occurrence.isAddToCartActive">
											<div *ngFor="let option of occurrence.productPricingOptions"
												[class.d-none]="option.quantity == 0"
												class="font-weight-medium">{{option.quantity}} {{option.useName}}</div>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-4 mb-3 mb-md-0">
									<div class="font-weight-bold">Total For {{occurrence.date | date: 'MMMM dd, yyyy'}}</div>

									<div class="" *ngIf="!occurrence.isAddToCartActive">Nothing selected</div>
									
									<div class="py-2"
										*ngIf="occurrence.isAddToCartActive">
										<div *ngFor="let option of occurrence.productPricingOptions"
											[class.d-none]="option.quantity == 0"
											[class.d-flex]="option.quantity > 0"
											>{{option.displayPrice | currency: 'USD'}} x {{option.quantity}} {{option.useName}} <span class="ml-auto">{{option.displayPrice * option.quantity | currency: 'USD'}}</span></div>

										<hr>
										<div class="d-flex">
											<span>Total</span>
											<span class="ml-auto">{{occurrence.totalPrice | currency: 'USD'}}</span>
										</div>
									</div>

									<button class="btn btn-primary pill mt-3 font-weight-bold" 
										(click)="addToCart(occurrence)"
										*ngIf="occurrence.isAddToCartActive && !occurrence.wasJustAdded"
										[disabled]="!occurrence.isUnsaved">
										<span *ngIf="!occurrence.alreadyInCart">Add to Cart</span>
										<span *ngIf="occurrence.alreadyInCart">Update Cart</span>
									</button>

									<button class="btn btn-success pill mt-3 font-weight-bold text-white" 
										*ngIf="occurrence.wasJustAdded"
										(click)="goToCart()"
										>
										Cart was Updated
									</button>
									
								</div>

								<!-- <div class="bred text-small mb-2">{{occurrence | json}}</div> -->
							</div>
						</div>
						
					</div>

				</ng-container>




				<!-- <a class="btn btn-link text-danger my-1 text-small pl-0" 
					(click)="clearCart()"
					*ngIf="cart?.items?.length > 0">Clear Cart</a> -->


			</div>
		</div>
	</div>




	<div class="container bg-white rounded-corners content-inner xtra-pad mb-4" 
		id="details"
		(visibilityChange)="anchorTabComponent.visibilityChangeHandler($event)" 
		enterTheViewportNotifier
		>
		<div class="row">
			<div class="col-12 col-md-3">
				<h3 class="font-weight-bold text-secondary">Excursion Details</h3>
			</div>
			<div class="col-12 col-md-9" *ngIf="product?.content">
				<ng-container *ngIf="product.content?.highlights">
					<div class="font-weight-bold">Highlights</div>
					<div class="mb-4" [innerHTML]="product.content?.highlights"></div>
				</ng-container>

				<ng-container *ngIf="product.content?.knowBeforeYouBook">
					<div class="font-weight-bold">Know Before You Book</div>
					<div class="mb-4" [innerHTML]="product.content?.knowBeforeYouBook"></div>
				</ng-container>

				<ng-container *ngIf="product.content?.included && product.content?.included[0] != ''">
					<div class="font-weight-bold">What's Included</div>
					<ul class="mb-4">
						<li *ngFor="let item of product.content?.included" [innerHTML]="item"></li>
					</ul>
				</ng-container>

				<ng-container *ngIf="product.content?.excluded && product.content?.excluded[0] != ''">
					<div class="font-weight-bold">What's Not Included</div>
					<ul class="mb-4">
						<li *ngFor="let item of product.content?.excluded" [innerHTML]="item"></li>
					</ul>
				</ng-container>

				<ng-container *ngIf="product.content?.restrictions">
					<div class="font-weight-bold">Restrictions</div>
					<div class="mb-4" [innerHTML]="product.content?.restrictions"></div>
				</ng-container>

				<ng-container *ngIf="product.content?.specialInstructions">
					<div class="font-weight-bold">Special Instructions</div>
					<div class="mb-4" [innerHTML]="product.content?.specialInstructions"></div>
				</ng-container>

				<ng-container *ngIf="cancelationType != 1">
					<!-- <div class="font-weight-bold">Cancellation Policy</div> -->

					<hr class="my-4">

					<div class="d-flex mb-3">
						<fa-icon [icon]="['fas', 'exclamation-triangle']" class="mr-2 text-orange"></fa-icon>
						<div class="font-weight-bold text-green-dark">Special Cancellation Policy</div>
					</div>

					<app-cancel-policy
						[cancelationType]="cancelationType"
						[product]="product"
						className=""></app-cancel-policy>

					<hr class="my-4">
					
				</ng-container>
				
			</div>
		</div>
	</div>

	<div class="container bg-white rounded-corners content-inner xtra-pad mb-4"
		id="location"
		(visibilityChange)="anchorTabComponent.visibilityChangeHandler($event)" 
		enterTheViewportNotifier
		*ngIf="product?.locations && product.locations.length > 0 && product.locations[0].address.addressDisplay"
		>
		<div class="row">
			<div class="col-12 col-md-3">
				<h3 class="font-weight-bold text-secondary">Location</h3>
			</div>
			<div class="col-12 col-md-9">
				<!-- <div><img src="https://fpoimg.com/800x300?text=map" width="100%"></div> -->
				<!-- <div class="mb-3"><img src="{{staticMapStr}}" width="100%"></div> -->
				<!-- <div class="text-small text-danger mb-3 break-anywhere">{{staticMapStr}}</div> -->

					
				<div class="" style="height: 300px" *ngIf="displayMap && mapsApiLoaded">
					<google-map
						height="100%"
						width="100%"
						[zoom]="mapZoom"
						[center]="mapCenter"
						[options]="mapOptions"
						>
						<map-marker
							#somemarker="mapMarker"
							*ngFor="let marker of markers"
							[position]="marker.position"
							[label]="marker.label"
							[title]="marker.title"
							[options]="marker.options"
							(mapClick)="openInfo(somemarker, marker.info)"
						>
						</map-marker>
						<map-info-window [innerHTML]="infoContent"></map-info-window>
					</google-map>
				</div>

				<ng-container *ngFor="let loc of product?.locations; let i = index;">
					<a *ngIf="loc.name || loc.address.addressDisplay"
						class="mt-3 location btn btn-link d-block text-left underline-onhover "
						[href]="getGoogleMapsLocUrl(loc)"
						target="_blank">
						<div class="font-weight-bold d-flex"><span>{{loc.name}}</span><fa-icon [icon]="['fas', 'external-link-alt']" class="ml-3 text-small" [ngStyle]="{'margin-top': '4px'}"></fa-icon></div>
						<div class="address" *ngIf="loc.address" [innerHTML]="loc.address.addressDisplay"></div>
					</a>
				</ng-container>
				
				

			</div>
		</div>
	</div>

	<div class="container bg-white rounded-corners content-inner xtra-pad mb-4 reviews" 
		id="reviews"
		(visibilityChange)="anchorTabComponent.visibilityChangeHandler($event)" 
		enterTheViewportNotifier
		>
		<div class="row">
			<div class="col-12 col-md-3">
				<h3 class="font-weight-bold text-secondary">Reviews</h3>
					<div class="rating mr-2 d-inline-block">
						<div class="mb-2 icon-circle-white">
							<fa-icon [icon]="['fas','thumbs-up']" class=""></fa-icon>
						</div>
						<div class="">{{reviewLikes}}</div>
					</div>
					<div class="rating d-inline-block">						
						<div class="mb-2 icon-circle-primary">
							<fa-icon [icon]="['fas','thumbs-down']"></fa-icon>
						</div>
						<div class="">{{reviewDislikes}}</div>
					</div>
				<hr>
				<ng-container>
					<div class="font-weight-bold form-label">Sort By</div>
					<select class="form-control" (change)="sortReviews($event)">
						<!-- <option>Featured</option> -->
						<option selected>Recent</option>
						<option>Liked</option>
						<option>Disliked</option>
					</select>
				</ng-container>
			</div>
			<div class="col-12 col-md-9">				
				<div *ngFor="let review of reviews; index as i" [ngClass]="{'review': true, 'first': i == 0, 'second': i == 1, 'mb-3': i != reviews?.length - 1}">
					<div class="row">
						<div class="col">
							<div class="h3 font-weight-bold mb-4">{{review.headline}}</div>
							<div class="font-weight-bold date mb-4">{{review.userDisplayName ? review.userDisplayName + " - " : ""}} {{review.createdOn | date: "MMM yyyy"}}</div>
						</div>
						<div class="col-auto">
							<div class="mb-2 mr-2 d-inline-block" [ngClass]="{'icon-circle-white-lg': review.rating == 1, 'icon-circle-primary-lg': review.rating == 0}">
								<fa-icon *ngIf="review.rating == 1" [icon]="['fas','thumbs-up']"></fa-icon>
								<fa-icon *ngIf="review.rating == 0" [icon]="['fas','thumbs-down']"></fa-icon>
							</div>
						</div>
					</div>
					<div *ngIf="review.content && review.content.length > 350; then readMoreBlock else readAllBlock"></div>
					<ng-template #readMoreBlock>
						<app-read-more 
							[isAnimated]="false" 
							minHeight="90" 
							maxHeight="1000"
							>
							<markdown class="text-gray" ngPreserveWhitespaces [innerHTML]="review.content"></markdown>
							<span class="read-more-text">Read More</span>
							<span class="read-less-text">Read Less</span>
						</app-read-more>
					</ng-template>
					<ng-template #readAllBlock>{{review.content}}</ng-template>
				</div>

				<div class="d-flex justify-content-center mt-2">
					<button class="btn btn-primary load-more" *ngIf="hasMoreReviews" (click)="loadMoreReviews()">Load More</button>
				</div>
			</div>
		</div>
		
	</div>




	<!-- <div class="container bg-white rounded-corners content-inner xtra-pad mb-4" 
		id="reviews"
		(visibilityChange)="anchorTabComponent.visibilityChangeHandler($event)" 
		enterTheViewportNotifier
		>
		<div class="row">
			<div class="col-12 col-md-3">
				<h3 class="font-weight-bold text-secondary">Reviews</h3>
			</div>
			<div class="col-12 col-md-9">
				<div class="">No reviews yet</div>
			</div>
		</div>
	</div> -->
	<!-- <button class="btn btn-outline-primary pill disabled">Show More Reviews</button> -->

</div>



<div class="container-fluid overflow-hidden" *ngIf="sliderListMore$ | async as sliderListMore;">
	<div class="container pt-4 pb-3">
		<!-- <ng-template #noSliderListMore>
			<div class="my-3">No Slider List More found.</div>
		</ng-template> -->
	

			<ascedia-swiper-card-image className="mb-5"
				[sliderList]="sliderListMore"
				[hasFavorites]="false"
				[breakpoints]="breakpoints"
				text="More In {{product.destination.name}}"
				className="overflow-visible"
				(toggleFavorite)="toggleFavorite($event)"
				>
			</ascedia-swiper-card-image>


		
	</div>

</div>


<app-itinerary-navigator [arriveDate]="arriveDate" *ngIf="arriveDate"></app-itinerary-navigator>


<ng-template #ticketsTemplate>
	<div class="modal-header align-items-center">
		<h3 class="font-weight-bold text-secondary mb-0">Select Quantity</h3>
		<button type="button" class="modal-close ml-auto" aria-label="Close" (click)="closeTicketModal()"><fa-icon [icon]="['fas', 'times']"></fa-icon></button>
	</div>
	<div class="modal-body">
		<!-- <div>{{modalService.config.initialState.test}}</div> -->
		<div *ngFor="let option of modalService.config.initialState.occurrence.productPricingOptions">
			<div class="d-flex">
				<div class=" text-secondary">
					<div class="font-weight-bold">
						<span class="mr-2">{{option.useName}}:</span>
						<span class="font-weight-bold">{{option.displayPrice | currency: 'USD'}}</span>
					</div>
					<div class="text-gray-500">{{option.shortDescription}}</div>
				</div>
				<div class="d-flex align-items-center ml-auto">
					<button type="button" class="ticket-edit" aria-label="Remove" (click)="editOption(option, 'remove', modalService.config.initialState.occurrence)"><fa-icon [icon]="['fal', 'minus']"></fa-icon></button>
					<div class="mx-3 font-weight-bold text-secondary" [ngStyle]="{'opacity': option.quantity == 0 ? .5 : 1}">{{option.quantity}}</div>
					<button type="button" class="ticket-edit" aria-label="Add" (click)="editOption(option, 'add', modalService.config.initialState.occurrence)"><fa-icon [icon]="['fal', 'plus']"></fa-icon></button>
				</div>
			</div>
			<hr>
			
		</div>

		
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-primary pill ml-auto" aria-label="Close" (click)="closeTicketModal()">Done</button>
	</div>
</ng-template>

<ng-template #signInModalTemplate>
	<div class="modal-header align-items-center pb-0">
		<button type="button" class="modal-close small ml-auto no-shrink" aria-label="Close" (click)="closeSignInModal()"><fa-icon [icon]="['fas', 'times']"></fa-icon></button>
	</div>
	<div class="modal-body pt-0">
		<!-- <div>{{modalService.config.initialState.test}}</div> -->
		<h3 class="font-weight-bold text-secondary text-center mb-4">You must Sign In before you can proceed.</h3>
		<div class="d-flex flex-column">
			<button type="button" class="btn btn-primary pill mb-2" aria-label="Sign In" (click)="signIn()">
				<span>Sign In</span>
			</button>
			<button type="button" class="btn btn-primary pill mb-2" aria-label="Sign In" (click)="createAccount()">
				<span>Create Account</span>
			</button>
			<button type="button" class="btn btn-link pill" aria-label="Cancel" (click)="closeSignInModal()">Cancel</button>
		</div>
		
		
	</div>
	<!-- <div class="modal-footer"></div> -->
</ng-template>